import { Component, Input, OnInit, HostListener, Output, EventEmitter, ViewChild, NgZone, ChangeDetectorRef, ElementRef  } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap';
import { TranslatePipe } from 'ng2-translate';
import { FiscalYear } from '../../entities';
import { AuthenticationService } from '../../services/http/authentication.service';
import { ToastrService } from 'toastr-ng2';

@Component({
  selector: 'login',
  template: require('./login.component.html'), 
  styles: [require('./login.component.scss')]
})
export class LoginComponent implements OnInit{

    private userName: string = '';
    private password: string = '';

    public loginBtnEnabled: boolean = true;

    constructor(private router:Router,
        private authenticationService:AuthenticationService, 
        private changeDetectorRef:ChangeDetectorRef, 
        private toast: ToastrService) {}

    ngOnInit(){

    }

    public login(form):void{
        this.loginBtnEnabled = false;
        this.authenticationService.login(this.userName, this.password)
            .then(loginAccess => {
                this.loginBtnEnabled = true;
                form.reset();
                this.router.navigateByUrl('/');
            })
            .catch((error) => {
                this.loginBtnEnabled = true;
                console.log('login error:', error);
                this.toast.error('Bad username or password', 'Error');
            });
    }

    public cancelLogin(form):void{
        form.reset();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/pages/login/login.component.ts